import { render, staticRenderFns } from "./c_page_ueditor.vue?vue&type=template&id=39f7adbf&scoped=true"
import script from "./c_page_ueditor.vue?vue&type=script&lang=js"
export * from "./c_page_ueditor.vue?vue&type=script&lang=js"
import style0 from "./c_page_ueditor.vue?vue&type=style&index=0&id=39f7adbf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f7adbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f7adbf')) {
      api.createRecord('39f7adbf', component.options)
    } else {
      api.reload('39f7adbf', component.options)
    }
    module.hot.accept("./c_page_ueditor.vue?vue&type=template&id=39f7adbf&scoped=true", function () {
      api.rerender('39f7adbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_page_ueditor.vue"
export default component.exports